import * as React from 'react';
import { relative } from 'path';
import reservationStore from "../../store/reservationStore";
import {useEffect} from "react";
import api from "../../utils/api";
import * as util from "../../utils/util";
import * as paymentInterface from "../../utils/paymentInterface";
import { bounceIfContextMissing } from "../../utils/reservationContext";

import SetCounselHospital from "./counsel/SetCounselHospital";
import SetCounselDate from "./counsel/SetCounselDate";
import SetCounselItem from "./counsel/SetCounselItem";
import SetCounselPay from "./counsel/SetCounselPay";
import SetFinish from './SetFinish';
import Box from '@mui/material/Box';
import Top from "../Top";
import Bottom from "../Bottom";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import WhereToVoteOutlinedIcon from '@mui/icons-material/WhereToVoteOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { StepIconProps } from '@mui/material/StepIcon';
import {useLocation, useNavigate} from "react-router-dom";
import axios from 'axios';

export type RequestPayResponseCallback = (response: paymentInterface.RequestPayResponse) => void;

export interface Iamport {
  init: (accountID: string) => void;
  request_pay: (
    params: paymentInterface.RequestPayParams,
    callback?: RequestPayResponseCallback,
  ) => void;
}

declare global {
  interface Window {
    IMP?: Iamport;
  }
}

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 32,
  height: 32,
  display: 'flex',
  borderRadius: '50%',
  flexDirection: 'column' ,
  justifyContent: 'center',
  alignItems: 'center',
  position:'relative',
  top:'-3px',
 
  ...(ownerState.active && {

    background: '#ef8322',
    boxShadow: '0 0px 0px 8px #FFD3AC',
  }),
  ...(ownerState.completed && {
    background: '#FFB26D',
      
  }),

}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <WhereToVoteOutlinedIcon sx={{ width: 20,  }}/>,
    2: <CalendarMonthOutlinedIcon sx={{ width: 20,  }}/>,
    3: <ChecklistOutlinedIcon sx={{ width: 20,  }}/>,
    4: <CreditScoreOutlinedIcon sx={{ width: 20,  }}/>,
    5: <CheckCircleOutlineOutlinedIcon sx={{ width: 20,  }}/>
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

const steps = ['병원선택', '검진일자선택', '검진항목선택', '결제', '예약완료'];

const ReservationStep = () => {
  const storeData: any = reservationStore();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  /**
   * 네이티브 결제창을 띄운 뒤의 대기 상태. (건강검진 예약 ReservationStep 과 같은 이유)
   * 결제 결과를 모르는 채로 예약 내역으로 옮기면, 결제를 취소한 사용자가
   * 빈 목록 앞에 남겨져 무슨 일이 있었는지 알 수 없다.
   */
  const [paymentPending, setPaymentPending] = React.useState(false);
  const pendingTmpRef = React.useRef<{ tmpId: string; merchantUid: string } | null>(null);
  /**
   * 예약 접수 요청 중인지. 연타로 예약이 두 건 접수되는 것을 막는다.
   * (건강검진 예약 ReservationStep 과 같은 이유 — 그쪽 주석 참고)
   * 실제 잠금은 ref 가 하고, state 는 버튼 표시에만 쓴다.
   */
  const submittingRef = React.useRef(false);
  const [submitting, setSubmitting] = React.useState(false);

  const unlockSubmit = () => {
    submittingRef.current = false;
    setSubmitting(false);
  };
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});
  const [finishSendItems, setFinishSendItems] = React.useState({});
  const location = useLocation();
  const navigate = useNavigate();
  
  // 마법사에 필요한 값(companyInfo / FAM_INFO)이 없으면 어떤 단계도 정상 동작하지 않는다.
  // 빈 화면에 남겨두지 않고 상담 예약 시작 화면으로 되돌린다.
  useEffect(() => {
    bounceIfContextMissing(navigate, '/reservationCounsel');
  }, []);

  useEffect(() => {
    const jquery = document.createElement('script');
    jquery.src = 'https://code.jquery.com/jquery-1.12.4.min.js';
    const iamport = document.createElement('script');
    iamport.src = 'https://cdn.iamport.kr/v1/iamport.js';
    document.head.appendChild(jquery);
    document.head.appendChild(iamport);
    
    return () => {
      document.head.removeChild(jquery);
      document.head.removeChild(iamport);
      
      storeData.setReservationInfo('hosId', '');
      storeData.setReservationInfo('pkgId', '');
      storeData.setReservationInfo('addPrice', 0);
      storeData.setReservationInfo('date', '');
      storeData.setReservationInfo('time', '');
      storeData.setCloseItems([]);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    };
  }, []);

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let stopStep = false;
    let newSkipped = skipped;
    // 검진일자선택 => 검진항목선택 :: 예약날짜 미선택 체크
    if (activeStep === 1 && ((storeData.reservationInfo.date === undefined || storeData.reservationInfo.date === null || storeData.reservationInfo.date === '')
      || (storeData.reservationInfo.time === undefined || storeData.reservationInfo.time === null || storeData.reservationInfo.time === ''))) {
      alert('예약 날짜와 시간을 선택해주세요.');
      return false;
    }else if(activeStep === 2){
    // 검진유형, 선택/추가 검사 항목 체크 확인
      if((storeData.choiceLimitCount !== storeData.checkedInjectioList.filter((item:any) => item.ipClass !== '추가').length)){
        alert('[선택검사] 항목 선택이 필요합니다.');
        return false;
      }else if(storeData.choiceLimitCount === 0 && storeData.checkedInjectioList.length === 0){
        alert('[검진유형] 선택이 필요합니다.');
        return false;
      }
    }else if(activeStep === 3){
      stopStep = true;
      // 응답이 올 때까지 화면에 반응이 없어(타임아웃 5초) 사용자가 한 번 더 누르면
      // 예약이 두 건 접수된다.
      if (submittingRef.current) {
        return false;
      }
      submittingRef.current = true;
      setSubmitting(true);
      processReservation({});
    }

    if(!stopStep){
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1));
    if(activeStep === 1){
      storeData.setReservationInfo('date', '');
      storeData.setReservationInfo('time', '');
      storeData.setCloseItems([]);
    }else if(activeStep === 2){
      storeData.setReservationInfo('date', '');
      storeData.setReservationInfo('time', '');
      storeData.setCloseItems([]);
      storeData.setReservationInfo('addPrice', 0);
      storeData.setReservationInfo('pkgId', 0);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    }
  };
  
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  
  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  
  const drawStepContent = (activeStep:number) => {
    if(activeStep === 0){
      return (
        <SetCounselHospital handleNext={handleNext} />
      )
    }else if(activeStep === 1){
      return (
        <SetCounselDate handleNext={handleNext} handleBack={handleBack} />
      )
    }else if(activeStep === 2){
      return (
        <SetCounselItem />
      )
    }else if(activeStep === 3){
      return (
        <SetCounselPay />
      )
    }
    else if(activeStep === 4){
      return (
        <SetFinish finishSendItems={finishSendItems} />
      )
    }
  };
  
  const postMessage = (type: string, data: any) => {
    var win: any = window;
    win.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
  };
  
  async function processReservation(sendItems:any){
    // const sendItems = parseSendItemsJsonObjectify(inSendItems);
    // 결제 여부(IS_PAYMENT)가 이 두 값으로 결정된다. 없을 때 기본값으로 진행하면
    // 결제 대상인 예약을 무료로 접수하거나 그 반대가 될 수 있으므로 진행하지 않는다.
    // 예전에는 JSON.parse 가 예외를 던져 예약 접수가 통째로 조용히 실패했다.
    const companyInfo = util.readStoredJson("companyInfo");
    const FAM_INFOS = util.readStoredJson("FAM_INFO");
    if (companyInfo === null || FAM_INFOS === null) {
      unlockSubmit();
      bounceIfContextMissing(navigate, '/reservationCounsel');
      return;
    }
    const isRebateDirectly = String(companyInfo['is_rebate_directly']).toLowerCase() === 'true';
    const isRebateCounsel = String(companyInfo['is_rebate_counsel']).toLowerCase() === 'true';
    const counselrebatePrice = companyInfo.counsel_rebate_price;
    const isB2C = String(companyInfo['type']).toLowerCase() === "b2c";
    const isB2B2C = parseInt(FAM_INFOS.supportPercent) < 0 ;
    const counselPayment = true;
    const IS_PAYMENT = isRebateCounsel && ( counselrebatePrice > 0 );
    const cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    
    sendItems.userName = FAM_INFOS.famName;
    sendItems.email = FAM_INFOS.email;
    sendItems.phone = FAM_INFOS.phone;
    sendItems.address = FAM_INFOS.address;
    sendItems.buildingNum = FAM_INFOS.buildingNum;
    sendItems.zipcode = FAM_INFOS.zipcode;
    sendItems.cusId = cusId;
    sendItems.famId = storeData.reservationInfo.famId;
    sendItems.pkgId = storeData.reservationInfo.pkgId;
    sendItems.pipList = storeData.checkedInjectioList.map((item:any) => item.id);
    sendItems.firstWishDate = storeData.reservationInfo.date;
    sendItems.reservationTime = storeData.reservationInfo.time;
    sendItems.secondWishDate = '2099-12-31';  // 의미 없는 2차 예약일자 설정
    sendItems.additionalPrice = storeData.reservationInfo.addPrice;
    
    if ( IS_PAYMENT ) {
      await api.post(`customer/api/v2/customers/${encodeURIComponent(cusId)}/reservations/tmp/rebate/payments`, sendItems).then(res => {
        const data = res.data.data;
        const reservationTmpId = data["reservation_tmp_id"];
        const merchantUid = data["merchant_uid"];
        paymentIAMPORT(reservationTmpId, sendItems, companyInfo, merchantUid);
      }).catch(function (error) {
        // 실패를 알리지 않으면 버튼이 잠긴 채로 남아 사용자는 앱이 멈춘 것으로 본다
        console.log(error);
        unlockSubmit();
        alert('예약 접수 중 오류가 발생했습니다.\n네트워크 상태를 확인한 뒤 다시 시도해 주세요.');
      });
    } else {
      await api.post('customer/api/v1/CU_003_005', sendItems).then(res => {
        sendItems.reservationId = res.data.data['reservation_id'];
        setFinishSendItems(sendItems);
        // 예약 완료 메세지 푸쉬 알림
        /*postMessage('PushAlarm', JSON.stringify({
          title: '듀얼헬스'
          , contents: `[건강 검진] ${sendItems.userName}님 ${sendItems.firstWishDate} 일자로 예약 접수 되었습니다.`
        }));*/
        
        // 예약 완료 알림톡 — 부가 기능이라 실패해도 예약 접수 결과와 이동을 막지 않는다.
        sendAT( IS_PAYMENT ).catch((e: any) => {
          console.log(e);
          alert('예약은 접수되었습니다.\n알림톡 발송에만 실패했습니다.');
        });

        navigate('/MyPage/ReservationView');
      }).catch(function (error) {
        console.log(error);
        unlockSubmit();
        alert('예약 접수 중 오류가 발생했습니다.\n네트워크 상태를 확인한 뒤 다시 시도해 주세요.');
      });
    }
  }

  // 알림톡 관련 api
  const bizppurio = axios.create({
    baseURL: 'https://api.dualhealth.kr/nodes/bizppurio',
    timeout: 5000
  })

  // 알림톡 함수
  async function sendAT( isPayment : Boolean ) {

    // 세 값 중 하나라도 없으면 JSON.parse('') 가 예외를 던졌다. 호출부가 catch 하도록 명시한다.
    const companyInfo = util.readStoredJson("companyInfo");
    const FAM_INFOS = util.readStoredJson("FAM_INFO");
    const HOS_INFO = util.readStoredJson("HOS_INFO");
    if (companyInfo === null || FAM_INFOS === null || HOS_INFO === null) {
      throw Error('알림톡 전송에 필요한 정보가 없습니다. (companyInfo / FAM_INFO / HOS_INFO)');
    }

    const data = {
      type: companyInfo['type'],
      company_id: companyInfo['company_id'],
      company_name: companyInfo['company_name'],
      is_rebate_directly: companyInfo['is_rebate_directly'],
      rebate_price: companyInfo['rebate_price'],
      userName: FAM_INFOS['famName'],
      phone: FAM_INFOS['phone'],
      hospital_name: HOS_INFO['name'],
      package_name: storeData.pakageInfo && storeData.pakageInfo.result.name,
      firstWishDate: storeData.reservationInfo && storeData.reservationInfo.date,
      reservationTime: storeData.reservationInfo && storeData.reservationInfo.time,
      price: storeData.reservationInfo && storeData.reservationInfo.groudPrice,
    }

    const info = {
      service: {
        "type": data.type.toLowerCase(),
        "target": data.company_id.includes("#") || data.company_id.toLowerCase() === "dualhealth" ? "customer" : data.company_id.toLowerCase(),
        "name": "심리상담"
      },
      "company": {
        "name": data.company_name,
        "isRebateDirectly": isPayment,
        "rebatePrice": data.rebate_price
      },
      "family": {
        "name": data.userName,
        "phone": String(data.phone ?? '').replaceAll(/[^\d]/ig, "")
      },
      "reservation": {
        "hospitalName": data.hospital_name,
        "packageName": data.package_name,
        "firstWishDate": data.firstWishDate + ` ${String(data.reservationTime).slice(0, -2)}:${String(data.reservationTime).slice(-2)}`,
        "secondWishDate": '-',
        "confirmedDate": null,
        "priceToPay": data.price
      }
    }
    // 예전에는 .catch 로 alert 만 하고 undefined 를 받은 뒤 `sendMSG.data` 를 읽어
    // TypeError 가 났다. 알림톡은 부가 기능이므로 실패는 호출부가 판단하게 넘긴다.
    const sendMSG: any = await bizppurio.post('/v1/message?msg=reservation_register', info);
    return sendMSG.data;
  }
  
  // async 를 뺀 이유는 ReservationStep 의 같은 함수 주석 참고
  // (async 면 내부 예외가 호출부 .catch 에 잡히지 않아 연타 잠금이 안 풀린다)
  function paymentIAMPORT(reservationTmpId:any, sendItems:any, companyInfo:any, merchantUid:any) {
    const payParam = getPayParam(companyInfo, reservationTmpId, merchantUid, sendItems);
    const userCode = process.env.REACT_APP_IMP_SID || '';

    if (isReactNative()) {
      /* 리액트 네이티브 환경에 대응하기 */
      const params = {
        userCode,                                   // 가맹점 식별코드
        payParam                                    // 결제 데이터
      };
      const paramsToString = JSON.stringify(params);
      postMessage('Iamport', paramsToString);
      // 결제 결과를 알기 전에는 화면을 옮기지 않는다
      pendingTmpRef.current = { tmpId: String(reservationTmpId), merchantUid: String(merchantUid) };
      setPaymentPending(true);
    } else {
      /* 그 외 환경(모바일 웹 · PC 브라우저) — 포트원 JS SDK 로 결제창을 띄운다. */
      const { IMP } = window;
      // 예전에는 `IMP?.init(...)` 이라 스크립트가 아직 안 왔으면 조용히 넘어갔다
      if (!IMP) {
        unlockSubmit();
        alert('결제 모듈을 불러오지 못했습니다.\n네트워크 상태를 확인한 뒤 다시 시도해 주세요.');
        return;
      }
      /* 가맹점 식별하기 */
      IMP.init(userCode);
      IMP.request_pay(payParam, () => {}); // callback 함수 호출 안됨.
      // 잠금 해제 이유는 ReservationStep 의 같은 위치 주석 참고
      // (PC 에서 결제 팝업만 닫았을 때 버튼이 영영 비활성화되는 것을 막는다)
      unlockSubmit();
    }
  }

  /**
   * 네이티브 결제 브릿지(React Native WebView)가 있는지.
   * user agent 로 판정하면 앱이 아닌 모바일 웹에서도 postMessage 경로를 타는데,
   * 그 호출이 옵셔널 체이닝이라 조용히 무시되어 결제창이 뜨지 않은 채
   * 대기 오버레이만 남는다. (자세한 내용은 ReservationStep 의 같은 함수 주석)
   */
  function isReactNative() {
    const bridge = (window as any).ReactNativeWebView;
    return typeof bridge?.postMessage === 'function';
  }

  function getPayParam(companyInfo:any, reservationTmpId:any, merchantUid:any, sendItems:any){
    const customerUid = `${sendItems.cusId}-${sendItems.famId}`;
    const buyerAddress = `${sendItems.address} ${sendItems.buildingNum}`;
    const buyerPostcode = sendItems.zipcode;
    const buyerName = sendItems.userName;
    const buyerEmail = util.isEmail(sendItems.email) ? sendItems.email : '';
    const buyerTel = sendItems.phone;
    const paymentPrice = companyInfo.counsel_rebate_price;
    const productName = '듀얼헬스케어';
    // iamport 결제 진행 후 callback 함수가 실행되지 않고 해당 URL(결제 검증 화면)로 이동 함
    const mRedirectionUrl = `${window.location.protocol}//${window.location.host}/reservation/SetPayValidation?reservationTmpId=${reservationTmpId}&family_id=${encodeURIComponent(sendItems.famId)}&userName=${sendItems.userName}&wishDate=${sendItems.firstWishDate}`;
    const webhook = process.env.REACT_APP_WEBHOOK || '';
    
    return {
      pg: `html5_inicis.` + (process.env.REACT_APP_PGMID || ''),
      pay_method : 'card', // 'card'만 지원
      merchant_uid : merchantUid,
			app_scheme: '',
      name : productName, //상품명
      amount: paymentPrice,
      // customer_uid: customerUid, 비인증 결제용 파라미터
      buyer_email: buyerEmail,
      buyer_name: buyerName,
      buyer_tel : buyerTel,
      buyer_addr : buyerAddress,
      buyer_postcode : buyerPostcode,
      m_redirect_url: mRedirectionUrl,
      notice_url : webhook
    }
  }
  
  /*
  function setPaymentResponseIn(sendItems:any, rsp:any){
    try {
      let paymentResponse = {merchantUid: '', impUid: '', payMethod: '', amount: '', status: '', pgProvider: '', pgTid: ''};
      paymentResponse.merchantUid = rsp.merchant_uid;
      paymentResponse.impUid = rsp.imp_uid;
      paymentResponse.payMethod = rsp.pay_method;
      paymentResponse.amount = rsp.paid_amount;
      paymentResponse.status = rsp.status;
      paymentResponse.pgProvider = rsp.pg_provider;
      paymentResponse.pgTid = rsp.pg_tid;
      sendItems.paymentResponse = paymentResponse;
    } catch (e) {
    }
    return sendItems;
  }
  
  async function checkAndSavePayment( reservationTmpId:any, merchantUid:any, impUid:any, famId:any){
    api.post(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/${impUid}/payments/${merchantUid}?family_id=${encodeURIComponent(famId)}`, []).then(res => {
      if ( res.data.message.toString().toLowerCase() === "success" ||  res.data.success.toString().toLowerCase() === "true" ) {
        return res.data;
      }else {
        throw Error(res.data.message);
      }
    }).catch(function (error) {
      console.log(error)
    });
  }
    
  async function delReservationOfCanceledPayment ( reservationTmpId:any, merchantUid:any ){
    api.delete(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/payments/${merchantUid}`).then(res => {
      if ( res.data.success.toString().toLowerCase() !== "true" ) throw Error(res.data.message);
    }).catch(function (error) {
      console.log(error)
    });
  }
  */
  /*** 결제 로직 종료 **/
  
  

  /** 결제창을 닫았는데 리다이렉트가 오지 않은 경우의 탈출구 */
  const cancelPendingPayment = async () => {
    const pending = pendingTmpRef.current;
    setPaymentPending(false);
    unlockSubmit();
    pendingTmpRef.current = null;
    if (pending) {
      try {
        await api.delete(
          `customer/api/v2/customers/${encodeURIComponent(localStorage.getItem('userCusID') || '')}/reservations/tmp/${pending.tmpId}/rebate/payments/${pending.merchantUid}`,
        );
      } catch (error) {
        console.log(error);
      }
    }
    navigate('/reservationCounsel');
  };

  return (
    <Stack sx={{ width: '100%', minWidth:320, background:'#F1F2F4', }} spacing={2}>
      <Top title="예 약" />
      {paymentPending && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 1400,
            bgcolor: 'rgba(255,255,255,.94)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            px: 3,
            textAlign: 'center',
          }}
        >
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#333', mb: 1 }}>
            결제를 진행하고 있습니다
          </Typography>
          <Typography sx={{ fontSize: 14, color: '#777', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
            {'결제창에서 결제를 완료해 주세요.\n결제가 끝나면 자동으로 다음 화면으로 넘어갑니다.'}
          </Typography>
          <Button
            variant="outlined"
            onClick={cancelPendingPayment}
            sx={{ mt: 4, color: '#777', borderColor: '#bbb', borderRadius: '10px', px: 3, fontWeight: 700 }}
          >
            결제를 취소했어요
          </Button>
        </Box>
      )}
        <Box sx={{position:'relative', top:'56px'}}>
          <Typography sx={{ mt: 0, mb: 3, fontSize:'20px'}}  textAlign={'center'}>
            검진예약절차
          </Typography>

          <Stepper alternativeLabel  activeStep={activeStep} sx={{ bgcolor:'#fff', p:'30px 0', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd'}}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
              </Step>
              );
            })}
          </Stepper>
          
          {allStepsCompleted() ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
            </React.Fragment>
          ) : (
            drawStepContent(activeStep)
          )}
          
          <MobileStepper
            variant="progress"
            steps={steps.length+1}
            position="static"
            activeStep={activeStep}
            sx={{ width: '100%',  flexGrow: 1,  p:'0 20px 40px 20px', mb:10, mt:3, bgcolor:'#eeeff1', boxSizing:'border-box', display: activeStep === 0 || activeStep === 4 ? 'none' : 'flex',
              '& .MuiLinearProgress-root' : {display:'none'}
            }}
            nextButton={
              <Button size="small" onClick={handleNext} disabled={activeStep === 5 || submitting} sx={stepNextBtn}>
                {submitting ? "접수 중…" : "Next"}
                {theme.direction === 'rtl' ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight sx={{}} />
                )}
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0 || submitting} sx={stepNextBtn}>
                {theme.direction === 'rtl' ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Back
              </Button>
            }
          />
        </Box>
      <Bottom />
    </Stack >
  );
}
const stepNextBtn = {
  bgcolor: '#fff',
  color: '#ef8322',
  borderRadius:'30px',
  border:'1px solid #ef8322',
  width:'48%',
  p:'10px'


}





export default ReservationStep;